import styled from "styled-components";

const FinancialExpressLogo = styled.img.attrs(props => ({
    src: '/images/fe-logo-footer-sm.png'
}))`
    max-height: 72px;
`;

export default FinancialExpressLogo;